import { log } from '@swiper/core';
import { useEffect } from 'react';

export function useLogValue( label, value ) {
  useEffect( () => {
    if ( ! value ) return;
    log.debug( label, value );
  }, [ label, value ] );
}
